<mat-nav-list>
  <a
    data-testid="nav-partner-dashboard"
    mat-list-item
    [routerLink]="[Paths.PARTNER_COCKPIT_PATH, Paths.DASHBOARD_PATH]"
    routerLinkActive
    #dashboardRla="routerLinkActive"
    [activated]="dashboardRla.isActive"
    [routerLinkActiveOptions]="{ exact: false }"
    [matTooltip]="'navbar.dashboard' | translate"
    [matTooltipDisabled]="!isCollapsed"
    matTooltipPosition="right"
  >
    <mat-icon class="icon" fontIcon="dashboard" />
    <span>{{ 'navbar.dashboard' | translate }}</span>
  </a>
  <a
    data-testid="nav-partner-pentest-calendar"
    mat-list-item
    [routerLink]="[Paths.PARTNER_COCKPIT_PATH, Paths.PENTEST_CALENDAR_PATH]"
    routerLinkActive
    #pentestCalendarRla="routerLinkActive"
    [activated]="pentestCalendarRla.isActive"
    [routerLinkActiveOptions]="{ exact: false }"
    [matTooltip]="'navbar.pentestCalendar' | translate"
    [matTooltipDisabled]="!isCollapsed"
    matTooltipPosition="right"
  >
    <mat-icon class="icon" fontIcon="calendar_month" />
    <span>{{ 'navbar.pentestCalendar' | translate }}</span>
  </a>
  <a
    data-testid="nav-partner-customers"
    mat-list-item
    [routerLink]="[Paths.PARTNER_COCKPIT_PATH, Paths.CUSTOMERS_PATH]"
    routerLinkActive
    #customersRla="routerLinkActive"
    [activated]="customersRla.isActive"
    [routerLinkActiveOptions]="{ exact: false }"
    [matTooltip]="'navbar.customers' | translate"
    [matTooltipDisabled]="!isCollapsed"
    matTooltipPosition="right"
  >
    <mat-icon class="icon" fontIcon="domain" />
    <span>{{ 'navbar.customers' | translate }}</span>
  </a>
  <a
    data-testid="nav-partner-users"
    mat-list-item
    [routerLink]="[Paths.PARTNER_COCKPIT_PATH, Paths.USERS_PATH]"
    routerLinkActive
    #usersRla="routerLinkActive"
    [activated]="usersRla.isActive"
    [routerLinkActiveOptions]="{ exact: false }"
    [matTooltip]="'navbar.users' | translate"
    [matTooltipDisabled]="!isCollapsed"
    matTooltipPosition="right"
  >
    <mat-icon class="icon" fontIcon="groups" />
    <span>{{ 'navbar.users' | translate }}</span>
  </a>
</mat-nav-list>
